import React from 'react';
import s from './Loader.module.css';
import { JumpingDots } from '../animated-dots/JumpingDots';
import Loader from '../loader/Loader';
const SaveFrameLoader = () => {
    return (
        <div className={s.loading_save_frame}>
            <Loader
                text="Saving Image Project...
            Please wait couple of seconds"
            />
        </div>
    );
};

export default SaveFrameLoader;
